<template>
  <v-row>
    
   
    
    <v-col cols="6" class="pb-0">
      <aed-date-picker-auto 
        :label="labels.from" 
        v-model="localFrom" 
        dense
        :field="cleanedField"
        />
    </v-col>
    <v-col cols="6" class="pb-0">
      <aed-date-picker-auto 
        :label="labels.to" 
        v-model="localTo" 
        dense
        :field="cleanedField"
        />
    </v-col> 
    <v-col cols="12" v-if="hasError" class="pt-0">
        <span class="error--text ml-3 mb-2">{{ validationErrorMessage }}</span>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
import fieldMixin from '../mixins/field';
import helperMixin from '../mixins/helper';

export default {
  name: 'aedDateRange',
  // Angenommen, fieldMixin enthält getValidators()
  mixins: [fieldMixin], 
  props: {
    labels: Object,
    field: Object,
    from: String,
    to: String,
  },

  data() {
    // Initialisierung mit klassischer UND-Prüfung (kein Chaining)
    const fromValue = this.from || (this.field && this.field.VALUE && this.field.VALUE.length >= 1 && this.field.VALUE[0]);
    const toValue = this.to || (this.field && this.field.VALUE && this.field.VALUE.length >= 2 && this.field.VALUE[1]);

    return {
      localFrom: fromValue || '',
      localTo: toValue || '',
      
      // Zustand für die interne Validierung
      hasError: false,
      validationErrorMessage: '',
    };
  },
  
  computed: {
    // Entfernt MAXDAYS aus dem field-Objekt (muss an die Picker ohne übergeben werden)
    cleanedField() {
        if (!this.field) return {};
        // Destrukturierung erstellt eine flache Kopie ohne die MAXDAYS Eigenschaft
        const { MAXDAYS, ...rest } = this.field;
        return rest;
    },

    // Generiert die Validierungsregeln für die MAXDAYS-Grenze
    maxDaysRules() {
      const maxDays = this.field && this.field.MAXDAYS;
      
      if (!maxDays) {
        return { from: [], to: [] };
      }

      const maxDaysInt = parseInt(maxDays, 10);
      const dateFormat = "DD.MM.YYYY";

      const ruleFromTo = (value, otherDate) => {
        if (!otherDate || !value) return true;

        const dateCurrent = moment(value, dateFormat);
        const dateOther = moment(otherDate, dateFormat);

        const diffDays = Math.abs(dateCurrent.diff(dateOther, 'days'));

        if (diffDays > maxDaysInt) {
          return this.t('listtplinc','STR_ERR_DATERNG').replace('%d', maxDaysInt);
          
        }
        return true;
      };

      // Liefert die Regel für die combineRules() Methode zurück
      return { from: [ruleFromTo], to: [ruleFromTo] }; 
    },
  },

  watch: {
    // Beobachtet field.VALUE
    'field.VALUE': {
      handler(newValue) {
        if (newValue && newValue.length >= 1) {
          this.localFrom = newValue[0];
        }
        if (newValue && newValue.length >= 2) {
          this.localTo = newValue[1];
        }
      },
      immediate: true,
      deep: true,
    },
    
    // Beobachtet Props und aktualisiert localData
    from(newValue) {
      if (!newValue) return;
      this.localFrom = newValue;
      if (!this.localTo) {
         this.localTo = newValue;
      }
    },
    to(newValue) {
      if (!newValue) return;
      this.localTo = newValue;
    },
    
    // *** Wichtig: Führt Validierung bei Änderung aus ***
    localFrom(newValue) {
      this.validate(); 
      this.$emit('update:from', newValue);
    },
    localTo(newValue) {
      this.validate(); 
      this.$emit('update:to', newValue);
    },
  },
  
  methods: {
    // Kombiniert alle Standard- und MaxDays-Regeln
    getCombinedRules() {
        // Angenommen, getValidators() liefert ein Array von Standard-Validatoren
        const standardRules = this.getValidators(this.field);
        
        // Fügt die MaxDays-Regeln (egal ob von 'from' oder 'to') hinzu
        // Wir nehmen hier die 'from'-Regel, da sie identisch zur 'to'-Regel ist
        return [].concat(standardRules, this.maxDaysRules.from);
    },
    
    // Exponierte Methode: Führt die Validierung der gesamten Komponente aus
    validate() {
        this.hasError = false;
        this.validationErrorMessage = '';
        
        const rules = this.getCombinedRules();
        
        // Iteriert über alle Regeln
        for (const rule of rules) {
            
            // Führt die Regel mit localFrom und localTo aus
            // Hinweis: Standardregeln (z.B. required) prüfen nur localFrom.
            // Die MaxDays-Regel prüft das Verhältnis von localFrom/localTo.
            
            let validationResult = rule(this.localFrom, this.localTo);
            
            if (validationResult !== true) {
                this.hasError = true;
                this.validationErrorMessage = validationResult;
                return false; 
            }
        }
        
        return true; // Validierung erfolgreich
    }
  },

  created() {
    // Initialisierung beim Erstellen
    if (this.field && this.field.VALUE) {
      if (this.field.VALUE.length >= 1) {
        this.localFrom = this.field.VALUE[0];
        this.$emit('update:from', this.localFrom);
      }
      if (this.field.VALUE.length >= 2) {
        this.localTo = this.field.VALUE[1];
        this.$emit('update:to', this.localTo);
      }
    }
  },
};
</script>